<template>
  <v-container fluid class="pa-0">
    <!-- 顶部横幅 -->
    <div class="hero-section">
      <div class="hero-pattern"></div>
      <v-container>
        <v-row align="center" class="fill-height">
          <v-col cols="12" md="6" class="text-center text-md-left">
            <div class="hero-content">
              <div class="hero-logo mb-6">
                <v-icon icon="mdi-flower" size="64" color="pink-lighten-3"></v-icon>
              </div>
              <h1 class="text-h2 font-weight-bold mb-4 dream-text">
                品味知识的馨香
              </h1>
              <p class="text-h6 font-weight-regular mb-8 subtitle-text">
                在这里，与思想对话，与智慧共鸣
              </p>
              <v-btn
                color="pink-lighten-4"
                :to="{ name: 'PostEdit' }"
                size="x-large"
                class="px-8 write-btn"
                prepend-icon="mdi-pencil"
                elevation="0"
              >
                <span class="text-pink-darken-1">开始创作</span>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="d-none d-md-flex justify-center">
            <v-img
              src="https://cdn.vuetifyjs.com/images/cards/house.jpg"
              max-width="500"
              class="hero-image"
            ></v-img>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- 文章分类标签 -->
    <v-container class="mt-16">
      <v-row justify="center" class="mb-8">
        <v-col cols="auto">
          <v-chip-group
            v-model="selectedCategory"
            selected-class="pink-lighten-4"
          >
            <v-chip
              v-for="category in categories"
              :key="category"
              filter
              variant="elevated"
              class="ma-2 category-chip"
              color="pink-lighten-5"
            >
              <span class="text-pink-darken-1">{{ category }}</span>
            </v-chip>
          </v-chip-group>
        </v-col>
      </v-row>

      <!-- 文章列表 -->
      <v-row>
        <v-col v-for="post in posts" :key="post.id" cols="12" md="6" lg="4">
          <v-card 
            class="post-card" 
            :to="{ name: 'PostDetail', params: { id: String(post.id) }}"
            elevation="0"
          >
            <v-img
              :src="getRandomImage()"
              height="240"
              cover
              class="post-image"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="pink-lighten-4"
                  ></v-progress-circular>
                </v-row>
              </template>
              <div class="image-overlay d-flex align-center justify-center">
                <v-btn
                  color="white"
                  variant="text"
                  size="large"
                  icon="mdi-heart"
                  class="read-more-btn"
                ></v-btn>
              </div>
            </v-img>

            <v-card-item>
              <v-card-title class="text-h5 font-weight-bold mb-2 text-pink-darken-2">
                {{ post.title }}
              </v-card-title>
              <v-card-subtitle class="mb-2 d-flex align-center">
                <v-icon icon="mdi-calendar" size="small" class="mr-1 text-pink-lighten-1"></v-icon>
                <span class="text-pink-lighten-1">{{ post.date }}</span>
                <v-spacer></v-spacer>
                <v-chip
                  size="small"
                  color="pink-lighten-4"
                  variant="flat"
                  class="ml-2"
                >
                  <span class="text-pink-darken-1">技术博客</span>
                </v-chip>
              </v-card-subtitle>
            </v-card-item>

            <v-card-text class="text-body-1 text-grey-darken-1">
              {{ post.content.substring(0, 100) }}...
            </v-card-text>

            <v-divider class="mx-4"></v-divider>

            <v-card-actions class="pa-4">
              <v-row align="center" no-gutters>
                <v-col cols="auto">
                  <v-btn
                    variant="text"
                    color="pink-lighten-2"
                    class="px-0"
                    prepend-icon="mdi-heart"
                  >
                    {{ Math.floor(Math.random() * 1000) }}
                  </v-btn>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto">
                  <v-btn
                    :to="{ name: 'PostEdit', params: { id: String(post.id) }}"
                    color="pink-lighten-2"
                    variant="text"
                    icon="mdi-pencil"
                    @click.stop
                  ></v-btn>
                  <v-btn
                    @click.stop="confirmDelete(post.id)"
                    color="pink-lighten-2"
                    variant="text"
                    icon="mdi-delete"
                  ></v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- 删除确认对话框 -->
    <v-dialog v-model="showDeleteDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h5 pa-4 text-pink-darken-2">
          确认删除
        </v-card-title>
        <v-card-text class="pa-4">
          确定要删除这篇文章吗？此操作无法撤销。
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey-lighten-1"
            variant="text"
            @click="showDeleteDialog = false"
          >
            取消
          </v-btn>
          <v-btn
            color="pink-lighten-3"
            variant="elevated"
            @click="handleDelete"
          >
            确认删除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      showDeleteDialog: false,
      postToDelete: null,
      selectedCategory: 0,
      categories: ['全部', '技术', '生活', '随笔', '前端', '后端', 'AI'],
      images: [
        'https://source.unsplash.com/random/800x600/?programming',
        'https://source.unsplash.com/random/800x600/?technology',
        'https://source.unsplash.com/random/800x600/?coding',
        'https://source.unsplash.com/random/800x600/?computer',
        'https://source.unsplash.com/random/800x600/?developer'
      ],
      posts: [
        {
          id: 1,
          title: 'Vue.js 3.0 新特性详解',
          date: '2024-03-20',
          content: 'Vue.js 3.0带来了许多激动人心的新特性，比如Composition API、更好的TypeScript支持等...'
        },
        {
          id: 2,
          title: '前端工程化实践',
          date: '2024-03-18',
          content: '现代前端开发中，工程化已经成为必不可少的一环，本文将详细介绍前端工程化的最佳实践...'
        },
        {
          id: 3,
          title: 'Node.js性能优化指南',
          date: '2024-03-15',
          content: '如何提升Node.js应用的性能？本文将从多个角度探讨Node.js性能优化的策略...'
        }
      ]
    }
  },
  methods: {
    getRandomImage() {
      return this.images[Math.floor(Math.random() * this.images.length)]
    },
    confirmDelete(id) {
      this.postToDelete = id
      this.showDeleteDialog = true
    },
    handleDelete() {
      if (this.postToDelete) {
        // 实现删除逻辑
        this.showDeleteDialog = false
        this.postToDelete = null
      }
    }
  }
}
</script>

<style scoped>
.hero-section {
  position: relative;
  min-height: 600px;
  background: linear-gradient(135deg, #fce4ec 0%, #f3e5f5 50%, #e1f5fe 100%);
  display: flex;
  align-items: center;
  overflow: hidden;
}

.hero-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(circle at 1px 1px, rgba(255, 182, 193, 0.15) 1px, transparent 0);
  background-size: 40px 40px;
  opacity: 0.5;
}

.hero-content {
  position: relative;
  z-index: 1;
}

.dream-text {
  background: linear-gradient(45deg, #e91e63, #9c27b0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.subtitle-text {
  color: #9c27b0;
  opacity: 0.8;
}

.write-btn {
  transition: all 0.3s ease;
  border: 2px solid rgba(233, 30, 99, 0.1);
}

.write-btn:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg, #fce4ec, #f3e5f5) !important;
  border-color: rgba(233, 30, 99, 0.2);
}

.hero-image {
  transform: perspective(1000px) rotateY(-15deg);
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(233, 30, 99, 0.1);
  transition: transform 0.5s ease;
}

.hero-image:hover {
  transform: perspective(1000px) rotateY(-5deg);
}

.post-card {
  border-radius: 16px;
  transition: all 0.3s ease;
  overflow: hidden;
  background: linear-gradient(135deg, #ffffff, #fafafa);
  border: 1px solid rgba(233, 30, 99, 0.1);
}

.post-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(233, 30, 99, 0.1) !important;
  border-color: rgba(233, 30, 99, 0.2);
}

.post-image {
  position: relative;
  overflow: hidden;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(233, 30, 99, 0.3), rgba(156, 39, 176, 0.3));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.post-card:hover .image-overlay {
  opacity: 1;
}

.read-more-btn {
  transform: scale(0.8);
  opacity: 0;
  transition: all 0.3s ease;
}

.post-card:hover .read-more-btn {
  transform: scale(1);
  opacity: 1;
}

.category-chip {
  transition: all 0.3s ease;
  border: 1px solid rgba(233, 30, 99, 0.1) !important;
}

.category-chip:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg, #fce4ec, #f3e5f5) !important;
  border-color: rgba(233, 30, 99, 0.2) !important;
}

.v-card-title {
  line-height: 1.5;
}
</style> 